import api from "./api";

export const authService = {
  login: async (credentials) => {
    console.log("🔐 [AUTH SERVICE] Login attempt started");
    const response = await api.post("/api/auth/login", credentials);
    console.log("🔐 [AUTH SERVICE] Login response received:", {
      hasData: !!response.data,
      hasDataData: !!response.data?.data,
      keys: Object.keys(response.data || {}),
    });
    
    // Handle both response structures: { data: {...} } or direct {...}
    const data = response.data?.data || response.data;
    console.log("🔐 [AUTH SERVICE] Extracted data:", {
      hasToken: !!data?.token,
      hasRefreshToken: !!data?.refreshToken,
      hasUser: !!data?.user,
      keys: Object.keys(data || {}),
    });

    // Store tokens if login is successful - ALWAYS store refreshToken if token exists
    if (data?.token) {
      console.log("💾 [AUTH SERVICE] Storing authToken");
      localStorage.setItem("authToken", data.token);
      
      // CRITICAL: Always store refreshToken if it exists, even if it's empty string
      if (data.refreshToken) {
        console.log("💾 [AUTH SERVICE] Storing refreshToken");
        localStorage.setItem("refreshToken", data.refreshToken);
      } else {
        console.error("❌ [AUTH SERVICE] WARNING: No refreshToken in response!");
        console.error("❌ [AUTH SERVICE] Response data:", data);
      }
      
      // Verify tokens were stored
      const storedToken = localStorage.getItem("authToken");
      const storedRefreshToken = localStorage.getItem("refreshToken");
      console.log("✅ [AUTH SERVICE] Tokens stored verification:", {
        authTokenStored: !!storedToken,
        refreshTokenStored: !!storedRefreshToken,
        refreshTokenLength: storedRefreshToken?.length || 0,
      });
    } else {
      console.error("❌ [AUTH SERVICE] No token in response data!");
    }

    return data;
  },

  register: async (userData) => {
    const response = await api.post("/api/auth/register", userData);
    return response.data.data || response.data;
  },

  refreshToken: async (refreshToken) => {
    const response = await api.post("/api/auth/refresh-token", {
      refreshToken,
    });
    return response.data.data || response.data;
  },

  logout: () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    localStorage.removeItem("refreshToken");
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const token = localStorage.getItem("authToken");
    return !!token;
  },

  // Get stored token
  getToken: () => {
    return localStorage.getItem("authToken");
  },

  // Get stored refresh token
  getRefreshToken: () => {
    return localStorage.getItem("refreshToken");
  },

  // Forget password - send OTP via phone or email
  forgetPassword: async (data) => {
    const response = await api.post("/api/auth/forget-password", data);
    return response.data;
  },

  // Verify OTP for password reset
  verifyOTP: async (data) => {
    const response = await api.post("/api/auth/verify-otp", data);
    return response.data;
  },

  // Reset password with OTP
  resetPassword: async (data) => {
    const response = await api.post("/api/auth/reset-password", data);
    return response.data;
  },
};

export default authService;
